export enum DenominationType {
    Fixed = 'Fixed',
    Variable = 'Variable'
}
